import React from 'react';

function PaginaPrivacidadePublica() {
  return (
    <main className="privacy-page">
      <section className="privacy-page__card" aria-labelledby="privacy-title">
        <div className="privacy-page__brand">
          <img src="/promoalert-panel-brand-dark.png" alt="PromoAlert" />
          <span>Painel do Lojista</span>
        </div>

        <div className="privacy-page__heading">
          <p>INFORMAÇÕES DE PRIVACIDADE</p>
          <h1 id="privacy-title">Política de Privacidade</h1>
        </div>

        <div className="privacy-page__content">
          <p>
            A sua privacidade é a nossa prioridade. O PromoAlert coleta, usa e protege os seus dados em total conformidade com a Lei Geral de Proteção de Dados (LGPD).
          </p>

          <h2>1. Quais dados coletamos e como usamos?</h2>

          <h3>Dados de Cadastro</h3>
          <p>Nome, e-mail e telefone, utilizados exclusivamente para a criação e segurança da sua conta.</p>

          <h3>Localização (GPS)</h3>
          <p>Utilizada apenas para definir geograficamente as ofertas mais próximas de você e garantir o funcionamento do Radar na sua região.</p>

          <h3>Dados de Navegação</h3>
          <p>Cliques e interesses em categorias para personalizar o seu feed.</p>

          <h3>Imagens e Publicações</h3>
          <p>Foto de perfil e imagens enviadas voluntariamente em ofertas, utilizadas somente para exibição dentro do PromoAlert.</p>

          <h2>2. Compartilhamento e Estatísticas</h2>
          <p>
            Os seus dados pessoais são estritamente confidenciais e não são compartilhados com terceiros. O sistema apenas agrupa dados de navegação de forma totalmente anônima para gerar estatísticas de demanda por região, incentivando os lojistas a publicarem ofertas melhores para a sua cidade. O compartilhamento operacional ocorre apenas com os nossos parceiros de tecnologia, como servidores e pagamentos, para manter o sistema no ar.
          </p>

          <h2>3. Os seus Direitos</h2>
          <p>
            Você tem controle total. A qualquer momento no aplicativo pode editar os seus dados, revogar as permissões de GPS ou solicitar a exclusão permanente da sua conta pelo Perfil. Também será disponibilizada uma página pública para solicitação de exclusão, com confirmação pelo e-mail vinculado à conta. Contas com assinatura, pagamento pendente ou vínculo comercial ativo precisam regularizar essa relação antes da exclusão.
          </p>
        </div>

        <div className="privacy-page__footer">
          <a href="/">Voltar ao painel</a>
          <span>&copy; {new Date().getFullYear()} VMS Sistemas e Divulgações. Todos os direitos reservados.</span>
        </div>
      </section>
    </main>
  );
}

export default PaginaPrivacidadePublica;
